const parseAgentDesignMarkdown = (value = '', filename = '') => {
	const markdown = value.replace(/\r\n?/g, '\n').trim();
	const frontmatter = markdown.startsWith('---\n') ? markdown.slice(4, markdown.indexOf('\n---\n', 4)) : '';
	const field = key => frontmatter.match(new RegExp(`^${key}:\\s*["']?(.*?)["']?\\s*$`, 'm'))?.[1]?.trim();
	const heading = markdown.match(/^#\s+(.+)$/m)?.[1]?.trim();
	const name = field('name') || heading || filename.replace(/\.md$/i, '').replace(/[-_]+/g, ' ').trim();
	const body = markdown.replace(/^---\n[\s\S]*?\n---\n/, '').replace(/^#\s+.+$/m, '');
	const description =
		field('description') ||
		body
			.split(/\n\s*\n/)
			.map(item => item.trim())
			.find(item => item && !item.startsWith('#') && !item.startsWith('-')) ||
		'';
	const colors = [];
	const seen = new Set();
	markdown.split('\n').forEach(line => {
		const match = line.match(
			/^\s*(?:[-*]\s*)?(?:\*\*)?([\w -]+?)(?:\*\*)?\s*[:=]\s*["'`]?((?:#(?:[\da-fA-F]{3,8})\b)|(?:rgb(?:a)?\([^)]*\))|(?:oklch\([^)]*\)))/,
		);
		if (!match || colors.length >= 12 || seen.has(match[2].toLowerCase())) return;
		seen.add(match[2].toLowerCase());
		colors.push({ name: match[1].trim(), value: match[2].trim() });
	});
	const errors = [];
	if (!markdown) errors.push('Import a design to continue.');
	if (markdown && markdown.length < 10) errors.push('The design document is too short.');
	if (markdown.length > 500_000) errors.push('DESIGN.md files must be smaller than 500 KB.');
	if (markdown.startsWith('---\n') && !markdown.includes('\n---\n', 4))
		errors.push('The front matter is missing its closing delimiter.');
	if (markdown && !name) errors.push('Include a name in front matter, an H1 heading, or a descriptive filename.');
	return { colors, description, errors, markdown: markdown ? `${markdown}\n` : '', name };
};

export { parseAgentDesignMarkdown };
